import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const PROMO_TYPES = [
  { key: "campaign_followup", label: "Campaign follow‑ups" },
  { key: "reminder", label: "General reminders" },
  { key: "special_offer", label: "Special offers" },
  { key: "event_notification", label: "Events & webinars" },
];

const NEWS_TYPES = [
  { key: "weekly_newsletter", label: "Weekly newsletter" },
  { key: "monthly_newsletter", label: "Monthly newsletter" },
];

const NotificationsTab = ({
  tabValue,
  index,
  promo,
  setPromo,
  news,
  setNews,
  frequency,
  setFrequency,
  toggleItem,
  toggleAllPromo,
  toggleAllNews,
}) => {
  if (tabValue !== index) return null;
  
  const navigate = useNavigate();  
  
  return (
    <Box id={`tab-contents-${index}`} sx={{ mt: 3 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
        Notification Preferences
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="subtitle1">Promotional & Reminders</Typography>
            <Button size="small" onClick={toggleAllPromo}>
              {promo.length === PROMO_TYPES.length ? "Unselect All" : "Select All"}
            </Button>
          </Box>
          <FormGroup>
            {PROMO_TYPES.map(({ key, label }) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={promo.includes(key)}
                    onChange={() => toggleItem(setPromo)(key)}
                  />
                }
                label={label}
              />
            ))}
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="subtitle1">Newsletters</Typography>
            <Button size="small" onClick={toggleAllNews}>
              {news.length === NEWS_TYPES.length ? "Unselect All" : "Select All"}
            </Button>
          </Box>
          <FormGroup>
            {NEWS_TYPES.map(({ key, label }) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={news.includes(key)}
                    onChange={() => toggleItem(setNews)(key)}
                  />
                }
                label={label}
              />
            ))}
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            label="Email frequency"
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Button
            variant="text"
            color="error"
            onClick={() => navigate("/delete_account")}
          >
            Delete account
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotificationsTab;